// ── Images ─────────────────────────────────────────────────────────────────
import IMG_LOGO from "../assets/logo.png";
// Transparent-ground version of the mark, used as the CSS mask on ink panels.
import IMG_LOGO_MARK from "../assets/logo-mark.png";


// ── Colors ─────────────────────────────────────────────────────────────────
// Six tokens sampled from the physical product and the printed logo. There is
// no accent colour: emphasis comes from weight, size and space, never hue.
// Mirrored as CSS custom properties in the CSS block below — keep both in sync.
const C = {
  background: "#F2EDE4", // page background, everywhere
  surface:    "#F5EFE6", // cards and slides, one step off the page
  ink:        "#7A5C4F", // logo brown — body text and headings
  inkStrong:  "#5C4438", // headings only, where more weight is needed
  inkMuted:   "#A08D80", // captions, placeholders, disabled states
  rule:       "#E3D9CC", // hairlines, borders, dividers
};

// ── Wompi El Salvador config ─────────────────────────────────────────────────
// The App ID and API Secret must stay on the server (api/wompi.php).
// This URL points to your PHP proxy which creates the payment link securely.
const WOMPI_API_PROXY  = "./api/wompi.php"; // ← PHP proxy (included in download)
const IG_HANDLE        = "handcraftsbyabu";

// ── Admin config ────────────────────────────────────────────────────────────
const MAX_ORDERS         = 20;
const MAX_PER_PRODUCT    = 8;

// ── API URL — update this to your Hostinger domain ───────────────────────────
const API_URL = "./api/products.php"; // change to full URL if needed e.g. "https://yourdomain.com/api/products.php"
const SEED_PRODUCTS_URL = "./seed-products.json";

// ── Translations ─────────────────────────────────────────────────────────────
const T = {
  es: {
    // Spanish copy is Salvadoran voseo throughout. Sentence case, no exclamation
    // points, and no claims about production beyond the one-week line time.
    // Nav
    nav_inicio:"Inicio", nav_tienda:"Tienda", nav_entrega:"Entrega", nav_nosotros:"Nosotros",
    nav_encargo:"Encargo a medida", nav_carrito:"Carrito",
    nav_inicio_m:"Inicio", nav_tienda_m:"Tienda", nav_entrega_m:"Entrega", nav_nosotros_m:"Nosotros",
    nav_encargo_m:"Encargo a medida",
    // Hero
    hero_tag:"Tejido en El Salvador",
    hero_sub:"Amigurumis y piezas religiosas tejidas una a la vez.",
    hero_desc:"Juguetes · Adornos · Vírgenes · Ángeles · Nacimientos\nEntregas a todo El Salvador",
    hero_btn1:"Ver la colección", hero_btn2:"Pedir un encargo",
    hero_badges:["Pieza única","Envío a todo El Salvador","Pago con Wompi","4,734 seguidores"],
    // Sections
    sec_favoritos:"Favoritos",
    sec_ver_todo:"Ver toda la colección →",
    sec_como:"Cómo funciona",
    sec_pagos:"Métodos de pago",
    sec_testimonios:"Lo que dicen los clientes",
    sec_encargo_cta:"Pedir un encargo",
    // Steps
    step1_t:"Elegí tu pieza",   step1_d:"Buscá en la tienda o contanos la idea que tenés en mente.",
    step2_t:"Pagá con Wompi",   step2_d:"Tarjeta, Puntos Agrícola o Bitcoin. El pago se procesa en la plataforma de Wompi El Salvador.",
    step3_t:"Abu la teje",      step3_d:"Cada pieza toma una semana de trabajo.",
    step4_t:"La recibís",       step4_d:"Envío a todo El Salvador y Estados Unidos, o retiro en persona.",
    // Tienda
    tienda_title:"Tienda",
    tienda_sub:"{n} piezas disponibles",
    tienda_buscar:"Buscar",
    tienda_todos:"Todos",
    tienda_encargo_cta:"¿No encontrás lo que buscás?",
    tienda_encargo_sub:"Contale a Abu la idea que tenés y ella te dice si puede tejerla.",
    tienda_encargo_btn:"Pedir un encargo",
    tienda_sin_stock:"Agotado",
    tienda_ver_mas:"Ver detalle",
    tienda_comprar:"Agregar al carrito",
    tienda_ul_stock:"Última pieza",
    // Nosotros
    nos_title:"Nuestra historia",
    nos_sub:"Handcrafts By Abu empezó como un pasatiempo y hoy envía piezas a todo El Salvador.",
    nos_hola:"Hola, soy Abu",
    nos_bio1:"Soy artesana salvadoreña y tejo amigurumi. Lo que empezó como un pasatiempo se volvió mi oficio.",
    nos_bio2:"Tejo cada pieza yo misma, una a la vez.",
    nos_ig:"Seguime en Instagram",
    nos_valores:"Cómo trabajo",
    nos_proceso:"El proceso",
    nos_cta_title:"¿Querés encargar algo?",
    nos_cta_sub:"Escribime por Instagram o hacé tu pedido acá.",
    nos_cta_btn1:"Ver la tienda", nos_cta_btn2:"Pedir un encargo",
    nos_faq_title:"Preguntas frecuentes",
    faqs:[
      ["¿Cuánto tarda un pedido?","Una semana de trabajo para cualquier pieza. Al confirmar el pedido te decimos la fecha de entrega."],
      ["¿Hacen envíos fuera de El Salvador?","Sí. Enviamos a todo El Salvador y a Estados Unidos. El costo para Estados Unidos se coordina directamente con Abu."],
      ["¿Cómo puedo pagar?","Con Wompi El Salvador: tarjeta de crédito o débito, Puntos Agrícola y Bitcoin (Chivo Wallet)."],
      ["¿Pueden personalizar los colores?","Sí. Al hacer tu encargo indicanos los colores y detalles que querés."],
      ["¿Qué pasa si mi pedido llega dañado?","Escribinos por Instagram con fotos y lo resolvemos."],
    ],
    valores:[
      {t:"Una pieza a la vez",d:"Abu teje cada pieza sola, sin máquinas."},
      {t:"Una semana de trabajo",d:"Ese es el tiempo de producción para toda la línea."},
      {t:"Hilo seguro para bebés",d:"Hilos suaves, sin químicos dañinos."},
      {t:"Tejido en El Salvador",d:"Con materiales de calidad y técnicas artesanales tradicionales."},
    ],
    proceso:[
      {n:1,t:"Consulta",d:"Contanos qué querés o elegí de la colección."},
      {n:2,t:"Diseño",d:"Abu define los colores y materiales con vos."},
      {n:3,t:"Tejido",d:"Una semana de trabajo, con técnica amigurumi japonesa."},
      {n:4,t:"Pago",d:"Pagás con Wompi y coordinamos la entrega."},
    ],
    testimonios:[
      {name:"Karla M.",stars:5,text:"Abu me hizo un osito para el baby shower de mi hermana y quedó hermoso. Super detallado y llegó antes de tiempo"},
      {name:"Roberto S.",stars:5,text:"La Virgen que me tejió es una obra de arte. Ya la tengo en el altar de mi mamá y todos preguntan dónde la conseguí."},
      {name:"Diana P.",stars:5,text:"Pedí una muñeca personalizada y Abu se aseguró que los colores quedaran perfectos. Volveré a pedir"},
      {name:"Margarita V.",stars:5,text:"El set bebé para mi nieta llegó súper bien empacado. Se nota el cuidado en cada detalle. 100% recomendado"},
    ],
    // Entrega
    delivery_title:"Entrega y zonas",
    delivery_sub:"Tiempos, costos y la zona que aplica a tu pedido.",
    delivery_lookup_label:"Tu ciudad, departamento o país",
    delivery_lookup_placeholder:"Ej: San Salvador, Santa Ana, Estados Unidos",
    delivery_lookup_button:"Ver mi zona",
    delivery_lookup_empty:"Escribí tu ubicación para ver la zona que te corresponde.",
    delivery_lookup_result:"Tu zona",
    delivery_lookup_fallback:"No reconocimos esa ubicación. Abu te la confirma por Instagram.",
    delivery_how_title:"Cómo funciona la entrega",
    delivery_how_steps:[
      "Hacé tu pedido desde la tienda o por encargo.",
      "Abu confirma la zona y el costo final.",
      "Recibís tu pieza por envío o la retirás en persona.",
    ],
    delivery_pickup_note:"También podés retirar en persona si preferís.",
    // Footer
    footer_sub:"Amigurumis y piezas religiosas tejidas en El Salvador.",
    footer_copy:"© 2025 Handcrafts By Abu · El Salvador",
    // Cart
    cart_title:"Tu carrito",
    cart_empty:"Todavía no agregaste nada.",
    cart_ver_tienda:"Ver la tienda",
    cart_subtotal:"Subtotal",
    cart_envio:"Envío en El Salvador desde $3. Para Estados Unidos, Abu confirma el costo.",
    cart_pagar:"Pagar",
    cart_remove_all:"Quitar",
    cart_empty_icon:"Tu carrito está vacío",
    // Detail modal
    detail_al_carrito:"Agregar al carrito",
    detail_comprar:"Pagar",
    // Custom order modal
    custom_title:"Encargo a medida",
    custom_sub:"Contame qué querés y te doy ideas de diseño.",
    custom_label:"¿Qué querés que Abu teja?",
    custom_placeholder:"Ej: una Virgen de Guadalupe con manto azul y dorado",
    custom_examples_label:"Imágenes de referencia",
    custom_examples_hint:"Hasta 3 imágenes. Sirven para mostrar el estilo que querés.",
    custom_examples_remove:"Quitar",
    custom_examples_error:"No se pudo leer esa imagen. Probá con otro archivo.",
    custom_btn_loading:"Buscando ideas",
    custom_btn:"Buscar ideas de diseño",
    custom_gusto:"¿Te sirve esta idea?",
    custom_ig:"Abu coordina los detalles por Instagram.",
    custom_hacer:"Pedir este encargo",
    custom_sent_title:"Tu mensaje está listo",
    custom_sent_sub:"Copiamos el texto y abrimos Instagram para que se lo mandés a",
    custom_sent_btn:"Cerrar",
    custom_copy_error:"No se pudo copiar el texto. Copialo a mano desde el recuadro de abajo.",
    custom_draft_label:"Mensaje para Instagram",
    custom_open_ig:"Abrir Instagram",
    custom_copy_again:"Copiar otra vez",
  },
  en: {
    // Nav
    nav_inicio:"Home", nav_tienda:"Shop", nav_entrega:"Delivery", nav_nosotros:"About",
    nav_encargo:"Custom order", nav_carrito:"Cart",
    nav_inicio_m:"Home", nav_tienda_m:"Shop", nav_entrega_m:"Delivery", nav_nosotros_m:"About",
    nav_encargo_m:"Custom order",
    // Hero
    hero_tag:"Crocheted in El Salvador",
    hero_sub:"Amigurumi and religious pieces, crocheted one at a time.",
    hero_desc:"Toys · Ornaments · Virgins · Angels · Nativity Sets\nShipping across El Salvador",
    hero_btn1:"View the collection", hero_btn2:"Request a custom piece",
    hero_badges:["One of a kind","Shipping across El Salvador","Pay with Wompi","4,734 followers"],
    // Sections
    sec_favoritos:"Favorites",
    sec_ver_todo:"View the full collection →",
    sec_como:"How it works",
    sec_pagos:"Payment methods",
    sec_testimonios:"What customers say",
    sec_encargo_cta:"Request a custom piece",
    // Steps
    step1_t:"Choose your piece", step1_d:"Browse the shop, or tell us the idea you have in mind.",
    step2_t:"Pay with Wompi",    step2_d:"Card, Agrícola Points or Bitcoin. Payment is processed on Wompi El Salvador.",
    step3_t:"Abu crochets it",   step3_d:"Every piece takes one week of work.",
    step4_t:"You receive it",    step4_d:"Shipping across El Salvador and the United States, or pickup in person.",
    // Tienda
    tienda_title:"Shop",
    tienda_sub:"{n} pieces available",
    tienda_buscar:"Search",
    tienda_todos:"All",
    tienda_encargo_cta:"Not finding what you want?",
    tienda_encargo_sub:"Tell Abu your idea and she will say whether she can crochet it.",
    tienda_encargo_btn:"Request a custom piece",
    tienda_sin_stock:"Sold out",
    tienda_ver_mas:"View details",
    tienda_comprar:"Add to cart",
    tienda_ul_stock:"Last one",
    // Nosotros
    nos_title:"Our story",
    nos_sub:"Handcrafts By Abu started as a pastime and now ships pieces across El Salvador.",
    nos_hola:"Hi, I'm Abu",
    nos_bio1:"I'm a Salvadoran artisan and I crochet amigurumi. What started as a pastime became my trade.",
    nos_bio2:"I crochet every piece myself, one at a time.",
    nos_ig:"Follow me on Instagram",
    nos_valores:"How I work",
    nos_proceso:"The process",
    nos_cta_title:"Want to order something?",
    nos_cta_sub:"Message me on Instagram or place your order here.",
    nos_cta_btn1:"View the shop", nos_cta_btn2:"Request a custom piece",
    nos_faq_title:"Frequently asked questions",
    faqs:[
      ["How long does an order take?","One week of work for any piece. We confirm the delivery date when you place the order."],
      ["Do you ship outside El Salvador?","Yes. We ship across El Salvador and to the United States. U.S. shipping is coordinated directly with Abu."],
      ["How can I pay?","Through Wompi El Salvador: credit or debit card, Agrícola Points and Bitcoin (Chivo Wallet)."],
      ["Can you customize colors?","Yes. When you place your custom order, tell us the colors and details you want."],
      ["What if my order arrives damaged?","Message us on Instagram with photos and we will sort it out."],
    ],
    valores:[
      {t:"One piece at a time",d:"Abu crochets each piece alone, without machines."},
      {t:"One week of work",d:"That is the production time across the whole line."},
      {t:"Yarn safe for babies",d:"Soft yarns, free from harmful chemicals."},
      {t:"Crocheted in El Salvador",d:"With quality materials and traditional artisan techniques."},
    ],
    proceso:[
      {n:1,t:"Consultation",d:"Tell us what you want, or choose from the collection."},
      {n:2,t:"Design",d:"Abu settles the colors and materials with you."},
      {n:3,t:"Crocheting",d:"One week of work, using Japanese amigurumi technique."},
      {n:4,t:"Payment",d:"You pay with Wompi and we arrange delivery."},
    ],
    testimonios:[
      {name:"Karla M.",stars:5,text:"Abu made me a little bear for my sister's baby shower and it was gorgeous. Super detailed and arrived ahead of time"},
      {name:"Roberto S.",stars:5,text:"The Virgin she crocheted is a work of art. It's on my mom's altar and everyone asks where I got it."},
      {name:"Diana P.",stars:5,text:"I ordered a custom doll and Abu made sure the colors were perfect. I'll be ordering again"},
      {name:"Margarita V.",stars:5,text:"The baby set for my granddaughter arrived beautifully packed. You can feel the care in every detail. 100% recommended"},
    ],
    // Entrega
    delivery_title:"Delivery and zones",
    delivery_sub:"Times, costs, and the zone that applies to your order.",
    delivery_lookup_label:"Your city, state, or country",
    delivery_lookup_placeholder:"E.g. San Salvador, Santa Ana, United States",
    delivery_lookup_button:"See my zone",
    delivery_lookup_empty:"Type your location to see which zone applies.",
    delivery_lookup_result:"Your zone",
    delivery_lookup_fallback:"We did not recognize that location. Abu confirms it on Instagram.",
    delivery_how_title:"How delivery works",
    delivery_how_steps:[
      "Place your order from the shop or as a custom piece.",
      "Abu confirms the zone and the final cost.",
      "You receive your piece by post, or pick it up in person.",
    ],
    delivery_pickup_note:"You can also pick up in person if you prefer.",
    // Footer
    footer_sub:"Amigurumi and religious pieces, crocheted in El Salvador.",
    footer_copy:"© 2025 Handcrafts By Abu · El Salvador",
    // Cart
    cart_title:"Your cart",
    cart_empty:"You have not added anything yet.",
    cart_ver_tienda:"View the shop",
    cart_subtotal:"Subtotal",
    cart_envio:"El Salvador shipping from $3. For the United States, Abu confirms the cost.",
    cart_pagar:"Pay",
    cart_remove_all:"Remove",
    cart_empty_icon:"Your cart is empty",
    // Detail modal
    detail_al_carrito:"Add to cart",
    detail_comprar:"Pay",
    // Custom order modal
    custom_title:"Custom order",
    custom_sub:"Tell me what you want and I will give you design ideas.",
    custom_label:"What would you like Abu to crochet?",
    custom_placeholder:"E.g. a Virgin of Guadalupe with a blue and gold mantle",
    custom_examples_label:"Reference images",
    custom_examples_hint:"Up to 3 images. They show the style you are after.",
    custom_examples_remove:"Remove",
    custom_examples_error:"That image could not be read. Try another file.",
    custom_btn_loading:"Looking for ideas",
    custom_btn:"Find design ideas",
    custom_gusto:"Does this work for you?",
    custom_ig:"Abu arranges the details on Instagram.",
    custom_hacer:"Request this piece",
    custom_sent_title:"Your message is ready",
    custom_sent_sub:"We copied the text and opened Instagram so you can send it to",
    custom_sent_btn:"Close",
    custom_copy_error:"The text could not be copied. Copy it by hand from the box below.",
    custom_draft_label:"Message for Instagram",
    custom_open_ig:"Open Instagram",
    custom_copy_again:"Copy again",
  },
};

// ── Shipping zones ──────────────────────────────────────────────────────────
const SHIPPING_ZONES = [
  { id:"sv_metro",  label:"San Salvador (Metro)",        price:3,  days:"1-2 días" },
  { id:"sv_local",  label:"El Salvador (Departamentos)", price:5,  days:"2-4 días" },
  { id:"us",        label:"Estados Unidos",              price:0,  days:"7-12 días", displayPrice:"Coordinar con Abu" },
  { id:"pickup",    label:"Recoger en persona",          price:0,  days:"Coordinar" },
];

// The one permitted exception to "no accent colour": these encode pipeline state
// a human has to read quickly. Desaturated into the palette — rendered as a
// small-caps label over a hairline rule, never as a coloured chip.
const ORDER_STATUS = {
  payment_pending: { label:"Pago pendiente", color:"#8C5F63" },
  pending:   { label:"Pendiente", color:"#84673B" },
  weaving:   { label:"Tejiendo",  color:"#6F5E7A" },
  ready:     { label:"Listo",     color:"#5E7158" },
  shipped:   { label:"Enviado",   color:"#5A6B7A" },
  delivered: { label:"Entregado", color:"#6E6058" },
  cancelled: { label:"Cancelado", color:"#8C5044" },
};

// Inline feedback borrows the same desaturated set, so errors and confirmations
// read as state without introducing a hue the palette does not have.
const FEEDBACK = {
  error:   ORDER_STATUS.cancelled.color,
  warning: ORDER_STATUS.pending.color,
  success: ORDER_STATUS.ready.color,
  info:    ORDER_STATUS.shipped.color,
};

// Two prices per product: priceBase for cash, transfer or pickup, and priceCard
// for the storefront, since checkout runs on Wompi. `price` is kept in sync with
// priceCard so the cart and the Wompi payload need no changes.
function normalizeProduct(product) {
  const card = product.priceCard ?? product.price ?? 0;
  return {
    ...product,
    priceBase: product.priceBase ?? null,
    priceCard: card,
    priceConfirmed: product.priceConfirmed === true,
    price: card,
  };
}
const normalizeProducts = list => (Array.isArray(list) ? list.map(normalizeProduct) : []);

const fmtMoney   = n => `$${Number(n).toFixed(2)}`;
const fmtDate    = d => new Date(d).toLocaleDateString("es-SV",{day:"2-digit",month:"short",year:"numeric"});
const todayStr   = () => new Date().toISOString().split("T")[0];
const genId      = () => "ORD-" + Date.now().toString(36).toUpperCase().slice(-6);

function calcCapacity(orders) {
  const active = orders.filter(o => !["payment_pending","delivered","cancelled"].includes(o.status));
  return { active: active.length, pct: Math.round(active.length / MAX_ORDERS * 100), max: MAX_ORDERS };
}
function calcProductLoad(orders) {
  const active = orders.filter(o => !["payment_pending","delivered","cancelled"].includes(o.status));
  const counts = {};
  active.forEach(o => o.items.forEach(i => { counts[i.productId] = (counts[i.productId]||0) + i.qty; }));
  return counts;
}
function calcTotals(items, zoneId) {
  const subtotal = items.reduce((s,i) => s + i.price * i.qty, 0);
  const zone     = SHIPPING_ZONES.find(z => z.id === zoneId) || SHIPPING_ZONES[0];
  return { subtotal, shipping: zone.price, total: subtotal + zone.price, zone };
}

// ── CSS ─────────────────────────────────────────────────────────────────────
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400&display=swap');

:root {
  /* Mirrors the C object above — keep both in sync. */
  --background:#F2EDE4;
  --surface:#F5EFE6;
  --ink:#7A5C4F;
  --ink-strong:#5C4438;
  --ink-muted:#A08D80;
  --rule:#E3D9CC;

  /* Three sizes per screen: display, body, label. */
  --text-display:clamp(30px,5vw,52px);
  --text-body:16px;
  --text-label:12px;

  /* With colour and shadow gone, whitespace carries the structure.
     The jump from --space-block to --space-group is what tells a reader
     whether two things belong together. Keep the ratio wide. */
  --space-section:clamp(80px,9vw,144px);  /* between full sections */
  --space-group:clamp(48px,5vw,72px);     /* between unrelated blocks */
  --space-block:28px;                     /* between related blocks */
  --space-tight:12px;                     /* within one block */
  --gutter:clamp(20px,5vw,64px);          /* page edge */
}

*, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
html { scroll-behavior:smooth; }

/* Form controls do not inherit the family on their own. */
button, input, select, textarea { font-family:inherit; }

body, .sans, .serif {
  font-family:'Playfair Display',Georgia,'Times New Roman',serif;
  font-weight:400;
  color:var(--ink);
}
body { background:var(--background); }

/* Three sizes per screen: display for the one page heading, body for
   everything else including section headings, label for small caps.
   Section headings separate themselves with space and tracking, not size. */
h1, h2, h3, h4 { font-weight:400; line-height:1.25; color:var(--ink); }
h1 { font-size:var(--text-display); font-weight:600; letter-spacing:-.02em; line-height:1.1; color:var(--ink-strong); }
h2 { font-size:var(--text-body); letter-spacing:.14em; text-transform:uppercase; color:var(--ink); margin-bottom:var(--space-group); }
h1 + p, h3 + p, h4 + p { margin-top:var(--space-tight); }
h3, h4 { font-size:var(--text-body); }
p, li, td, th, label, input, select, textarea, button { font-size:var(--text-body); line-height:1.7; }

/* Blocks that sit on ink. The .sans and h2 colour rules below would otherwise
   beat inheritance and paint ink-on-ink, so this scope has to name them. */
.on-ink, .on-ink h1, .on-ink h2, .on-ink h3, .on-ink h4,
.on-ink p, .on-ink a, .on-ink li, .on-ink span,
.on-ink .sans, .on-ink .serif, .on-ink .label, .on-ink .section-title {
  color:var(--background);
}

/* Small-caps labels are the only place letter-spacing opens up. */
.label {
  font-size:var(--text-label); text-transform:uppercase; letter-spacing:.14em;
  color:var(--ink); font-weight:500;
}

/* Keyboard focus stays visible on every interactive element. */
:where(a, button, input, select, textarea, [tabindex]):focus-visible {
  outline:2px solid var(--ink-strong);
  outline-offset:2px;
}

.btn {
  font-family:inherit; font-weight:400; font-size:var(--text-body);
  border:1px solid transparent; border-radius:2px; cursor:pointer;
  transition:background-color .18s ease, color .18s ease, border-color .18s ease;
  display:inline-flex; align-items:center; justify-content:center; gap:8px;
  line-height:1; text-decoration:none; white-space:nowrap;
}
.btn:disabled { color:var(--ink-muted); border-color:var(--rule); background:transparent; cursor:not-allowed; pointer-events:none; }

.btn-solid { background:var(--ink); color:var(--background); padding:14px 28px; }
.btn-solid:hover { background:var(--ink-strong); }

/* Retained for call sites that still ask for it; identical to .btn-solid. */
.btn-purple { background:var(--ink); color:var(--background); padding:14px 28px; }
.btn-purple:hover { background:var(--ink-strong); }

.btn-outline { background:transparent; color:var(--ink); border-color:var(--ink); padding:14px 28px; }
.btn-outline:hover { border-color:var(--ink-strong); color:var(--ink-strong); }

.btn-ghost { background:transparent; color:var(--ink); padding:10px 16px; }
.btn-ghost:hover { color:var(--ink-strong); }

.btn-white { background:var(--surface); color:var(--ink); border-color:var(--rule); padding:14px 28px; }
.btn-white:hover { border-color:var(--ink); }

.btn-full { width:100%; }

.nav-link {
  font-family:inherit; font-weight:400; font-size:var(--text-body); color:var(--ink);
  cursor:pointer; padding:6px 0; background:none; border:none;
  border-bottom:1px solid transparent; transition:color .18s, border-color .18s;
}
.nav-link:hover { color:var(--ink-strong); border-bottom-color:var(--rule); }
.nav-link.active { color:var(--ink-strong); border-bottom-color:var(--ink-strong); }

.product-card { background:var(--surface); border:1px solid var(--rule); display:flex; flex-direction:column; }
.product-card > div:last-child { padding:var(--space-block) var(--space-block) calc(var(--space-block) + 4px); }

/* Grids: the gutter between cards reads as "these are siblings". */
.products-grid { gap:var(--space-group) var(--space-block) !important; }
.values-grid, .steps-wrap, .testi-grid { gap:var(--space-group) !important; }

.badge {
  font-family:inherit; font-size:var(--text-label); font-weight:400;
  letter-spacing:.14em; text-transform:uppercase; padding:4px 0;
  background:transparent; color:var(--ink);
}

.pill {
  font-family:inherit; font-weight:400; font-size:var(--text-body); padding:10px 18px;
  border-radius:2px; cursor:pointer; border:1px solid var(--rule);
  background:transparent; color:var(--ink); transition:color .15s, border-color .15s;
}
.pill:hover { border-color:var(--ink); }
.pill.active { border-color:var(--ink-strong); color:var(--ink-strong); }

.search-input {
  font-family:inherit; font-size:var(--text-body); padding:10px 14px; border-radius:2px;
  border:1px solid var(--rule); background:var(--surface); color:var(--ink);
  outline:none; transition:border-color .18s; width:220px;
}
.search-input:focus { border-color:var(--ink); }
.search-input::placeholder { color:var(--ink-muted); }

.overlay { position:fixed; inset:0; background:rgba(92,68,56,.45); z-index:300; display:flex; align-items:center; justify-content:center; padding:16px; animation:fadeIn .2s ease; }
.modal { background:var(--background); border-radius:2px; padding:var(--space-group); max-width:560px; width:100%; max-height:90vh; overflow-y:auto; animation:slideUp .25s ease; border:1px solid var(--rule); }
.modal::-webkit-scrollbar { width:5px; }
.modal::-webkit-scrollbar-thumb { background:var(--rule); }

@keyframes fadeIn  { from{opacity:0} to{opacity:1} }
@keyframes slideUp { from{opacity:0;transform:translateY(26px)} to{opacity:1;transform:translateY(0)} }
@keyframes pop     { from{opacity:0} to{opacity:1} }
@keyframes spin    { to{transform:rotate(360deg)} }

.spinner { width:26px; height:26px; border:1px solid var(--rule); border-top-color:var(--ink); border-radius:50%; animation:spin .7s linear infinite; margin:24px auto; }

textarea, select,
input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="range"]) {
  width:100%; padding:12px 14px; border-radius:2px; border:1px solid var(--rule);
  font-family:inherit; font-size:var(--text-body); background:var(--surface); color:var(--ink);
  outline:none; transition:border-color .18s; line-height:1.65;
}
textarea { resize:vertical; min-height:108px; }
textarea:focus, input:focus, select:focus { border-color:var(--ink); }
textarea::placeholder, input::placeholder { color:var(--ink-muted); }

.pattern-box { background:var(--surface); border:1px solid var(--rule); border-radius:2px; padding:24px 26px; margin-top:20px; white-space:pre-wrap; font-family:inherit; font-size:var(--text-body); line-height:1.8; color:var(--ink); }

.added-flash { position:absolute; top:-10px; right:-10px; background:var(--ink); color:var(--background); font-family:inherit; font-size:var(--text-label); letter-spacing:.14em; text-transform:uppercase; padding:6px 12px; border-radius:2px; animation:pop .3s ease; z-index:2; white-space:nowrap; }

.cart-item { display:flex; align-items:center; gap:16px; padding:20px 0; border-bottom:1px solid var(--rule); }

.faq-item { border-bottom:1px solid var(--rule); }
.faq-q { width:100%; text-align:left; background:none; border:none; font-family:inherit; font-weight:400; font-size:var(--text-body); color:var(--ink); cursor:pointer; padding:22px 0; display:flex; justify-content:space-between; align-items:center; gap:12px; transition:color .15s; }
.faq-q:hover { color:var(--ink-strong); }
.faq-a { font-family:inherit; font-size:var(--text-body); line-height:1.75; color:var(--ink); padding:0 0 22px; display:none; }
.faq-a.open { display:block; }

.section-title { font-size:var(--text-body); letter-spacing:.14em; text-transform:uppercase; color:var(--ink); }
.step-card { background:transparent; padding:0; border:none; flex:1; min-width:150px; }
.step-num { font-family:inherit; font-size:var(--text-label); letter-spacing:.14em; color:var(--ink); margin:0 0 12px; }
.value-card { background:transparent; padding:0; border:none; }

/* Status labels — small caps over a hairline, colour carries state only. */
.status-label { font-family:inherit; font-size:var(--text-label); text-transform:uppercase; letter-spacing:.14em; padding-bottom:6px; border-bottom:1px solid var(--rule); display:inline-block; }

/* The mark on an ink panel. A brightness/invert filter would render it pure
   white, which is off-palette — masking paints it in the cream token exactly. */
.logo-on-ink {
  display:block;
  background-color:var(--background);
  -webkit-mask:url(${IMG_LOGO_MARK}) center/contain no-repeat;
  mask:url(${IMG_LOGO_MARK}) center/contain no-repeat;
}

/* Product images: fit-and-pad onto the page cream, never crop to fill. */
.product-media { background:var(--background); aspect-ratio:4 / 5; display:flex; align-items:center; justify-content:center; overflow:hidden; }
.product-media img { width:100%; height:100%; object-fit:contain; display:block; }

/* ── HAMBURGER MENU ── */
.hamburger { display:none; flex-direction:column; gap:5px; cursor:pointer; padding:8px; background:none; border:none; color:var(--ink); }
.hamburger span { display:block; width:22px; height:1.5px; background:var(--ink); transition:all .25s; }
.hamburger.open span:nth-child(1) { transform:translateY(7.5px) rotate(45deg); }
.hamburger.open span:nth-child(2) { opacity:0; transform:scaleX(0); }
.hamburger.open span:nth-child(3) { transform:translateY(-7.5px) rotate(-45deg); }

.mobile-menu {
  display:none; position:fixed; inset:0; top:68px; background:var(--background);
  z-index:49; flex-direction:column; padding:var(--space-group) var(--gutter);
  border-top:1px solid var(--rule);
  animation:slideDown .2s ease;
  overflow-y:auto;
}
.mobile-menu.open { display:flex; }
@keyframes slideDown { from{opacity:0;transform:translateY(-10px)} to{opacity:1;transform:translateY(0)} }

.mobile-nav-link {
  font-family:inherit; font-weight:400; font-size:var(--text-body);
  color:var(--ink); padding:18px 0; border-bottom:1px solid var(--rule);
  background:none; border-left:none; border-right:none; border-top:none;
  text-align:left; cursor:pointer; transition:color .15s;
}
.mobile-nav-link:hover, .mobile-nav-link.active { color:var(--ink-strong); }

@media (prefers-reduced-motion: reduce) {
  html { scroll-behavior:auto; }
  *, *::before, *::after {
    animation-duration:.01ms !important;
    animation-iteration-count:1 !important;
    transition-duration:.01ms !important;
  }
}

/* ── DESKTOP: hide mobile-only elements ── */
@media (min-width: 769px) {
  .mobile-actions { display:none !important; }
}

/* ── MOBILE BREAKPOINTS ── */
@media (max-width: 768px) {
  /* Clear the fixed action bar so it never sits on top of page content. */
  body { padding-bottom:calc(46px + 12px + var(--space-block)); }

  /* Nav */
  .desktop-nav { display:none !important; }
  .desktop-actions { display:none !important; }
  .hamburger { display:flex !important; }
  .nav-logo-wrap { flex:1; }

  /* Hero grid → stack */
  .hero-grid { grid-template-columns:1fr !important; gap:var(--space-group) !important; text-align:center; }
  .hero-grid .hero-text { order:1; }
  .hero-grid .hero-imgs { order:2; }
  .hero-grid .hero-text > div:first-child { justify-content:center; }
  .hero-btns { justify-content:center !important; }
  .hero-badges { justify-content:center !important; }
  .hero-imgs { grid-template-columns:1fr 1fr !important; }
  .hero-imgs > div { transform:none !important; height:110px !important; }

  /* About grid → stack */
  .about-grid { grid-template-columns:1fr !important; text-align:center; gap:var(--space-group) !important; padding:var(--space-group) var(--gutter) !important; }
  .about-grid > div:first-child { margin:0 auto; }
  .about-grid a { margin:0 auto; }

  /* Toolbar wrap */
  .toolbar-wrap { flex-direction:column !important; align-items:stretch !important; }
  .toolbar-wrap select { margin-left:0 !important; }
  .search-input { width:100% !important; }
  .pills-wrap { flex-wrap:wrap !important; }

  /* Steps → 2 col */
  .steps-wrap { display:grid !important; grid-template-columns:1fr 1fr !important; }

  /* Payment logos strip → smaller */
  .pay-strip { gap:var(--space-block) !important; padding:var(--space-block) 0 !important; flex-wrap:wrap; }

  /* Modal padding */
  .modal { padding:var(--space-group) var(--gutter) !important; }

  /* Cart item */
  .cart-item { gap:var(--space-tight) !important; }

  /* Nosotros hero */
  .nosotros-hero { padding:var(--space-section) var(--gutter) !important; }

  /* CTA sections */
  .cta-box { padding:var(--space-group) var(--gutter) !important; }
}

@media (max-width: 480px) {
  /* Tighter padding globally */
  section { padding-left:16px !important; padding-right:16px !important; }

  /* Nav height */
  .nav-inner { height:60px !important; }

  /* Hero */
  .hero-section { padding:var(--space-section) var(--gutter) !important; }

  /* Products single col on very small */
  .products-grid { grid-template-columns:1fr !important; }

  /* Steps single col */
  .steps-wrap { grid-template-columns:1fr !important; }

  /* Values 2 col */
  .values-grid { grid-template-columns:1fr 1fr !important; }

  /* Testimonials single col */
  .testi-grid { grid-template-columns:1fr !important; }

  /* Bottom CTA flex → stack */
  .bottom-cta { flex-direction:column !important; text-align:center !important; }

  /* Modal full screen on tiny phones */
  .modal { max-height:96vh !important; }

  /* Wompi button text */
  .pay-strip span { font-size:var(--text-label) !important; }

  /* Card form half-width inputs → full on tiny screens */
  .card-half { width:100% !important; margin-right:0 !important; }
}
`

// ─────────────────────────────────────────────────────────────────────────────
//  SHARED UI COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

export {
  API_URL,
  C,
  CSS,
  FEEDBACK,
  IG_HANDLE,
  IMG_LOGO,
  MAX_PER_PRODUCT,
  ORDER_STATUS,
  SEED_PRODUCTS_URL,
  SHIPPING_ZONES,
  T,
  WOMPI_API_PROXY,
  calcCapacity,
  calcProductLoad,
  calcTotals,
  fmtDate,
  fmtMoney,
  normalizeProduct,
  normalizeProducts,
  genId,
  todayStr,
};
